<script setup lang="ts">
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiClose } from '@mdi/js'
</script>
<template>
	<svg-icon type="mdi" :path="mdiClose"></svg-icon>
</template>
